module.exports = __webpack_public_path__ + "img/Dditoologo.54908f06.png";